<div
  class="flex flex-column justify-content-center align-items-center w-full gap-spacing-xs"
  [style]="'min-height: ' + minHeight()">
  <i class="icon-files icon-lightest-color size-icon-4xl"></i>
  <h4 class="label-large-regular text-light-color text-center">There are no records available.</h4>
</div>